import {
  CompanyOption,
  TargetOrganizationsInput,
} from "./TargetOrganizationsInput";
import { memo, useMemo, useState } from "react";
import { useFiltersContext } from "../../../pages/Workspace/UserFilters/FiltersContext";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useInsideFilterChip } from "../../../pages/Workspace/UserFilters/FiltersChips/hooks/useInsideFilterChip";
import { FilterLayout } from "../UserFilters/FilterLayout";

export const TargetOrganizationsFilter = memo(() => {
  const { draftFilters, setDraftFilters } = useFiltersContext();
  const { insideChip, elementRef } = useInsideFilterChip();

  const hgIdsIncludingCorporateRelatives = useMemo(
    () => draftFilters?.hgIdsIncludingCorporateRelatives || [],
    [draftFilters?.hgIdsIncludingCorporateRelatives]
  );

  const [includeCorporateRelatives, setIncludeCorporateRelatives] = useState(
    hgIdsIncludingCorporateRelatives.length > 0
  );

  const selectedCompanyIds = useMemo(() => {
    if (hgIdsIncludingCorporateRelatives.length > 0) {
      return hgIdsIncludingCorporateRelatives;
    }

    return draftFilters?.hgIds || [];
  }, [draftFilters?.hgIds, hgIdsIncludingCorporateRelatives]);

  const handleCompaniesSelect = (companies: CompanyOption[]) => {
    if (includeCorporateRelatives) {
      setDraftFilters((prevDraftFilters) => {
        return {
          ...prevDraftFilters,
          hgIds: [],
          hgIdsIncludingCorporateRelatives: companies.map(
            (company) => company.value
          ),
        };
      });
    } else {
      setDraftFilters((prevDraftFilters) => {
        return {
          ...prevDraftFilters,
          hgIds: companies.map((company) => company.value),
          hgIdsIncludingCorporateRelatives: [],
        };
      });
    }
  };
  const handleIncludeCorporateRelativesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setDraftFilters((prevDraftFilters) => {
        return {
          ...prevDraftFilters,
          hgIds: [],
          hgIdsIncludingCorporateRelatives: selectedCompanyIds,
        };
      });
      setIncludeCorporateRelatives(true);
    } else {
      setDraftFilters((prevDraftFilters) => {
        return {
          ...prevDraftFilters,
          hgIds: selectedCompanyIds,
          hgIdsIncludingCorporateRelatives: [],
        };
      });
      setIncludeCorporateRelatives(false);
    }
  };

  const handleClearFilter = () => {
    setDraftFilters({
      ...draftFilters,
      hgIds: [],
      hgIdsIncludingCorporateRelatives: [],
    });
    setIncludeCorporateRelatives(false);
  };

  return (
    <FilterLayout
      title="Target Organizations"
      onClear={handleClearFilter}
      showHeader={!insideChip}
      id="target-organizations-filter"
      refProp={elementRef}
    >
      <TargetOrganizationsInput
        onCompaniesSelect={handleCompaniesSelect}
        selectedCompanyIds={selectedCompanyIds}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={hgIdsIncludingCorporateRelatives.length > 0}
            onChange={handleIncludeCorporateRelativesChange}
          />
        }
        label="Include entire corporate tree"
      />
    </FilterLayout>
  );
});
